<div class="login-body" *ngIf="pageLogin">
    <div class="login-panel p-fluid">
        <div class="p-grid">
            <div class="p-col-12 logo-container">
                <img [src]="assestBaseUrl + 'layout/images/lionO360_logo1.png'" alt="logo-dark" />
                <h1>Login</h1>
                <hr>
            </div>

            <div class="p-col-12">
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="form-group p-mb-1">
                        <label for="username"><strong>Organization ID</strong><span style="color: red;">
                                *</span></label>
                        <input id="orgId" type="text" pInputText formControlName="orgCode" maxlength="7"
                            placeholder="Enter Organization Code" />
                    </div>
                    <div class="form-group p-mb-1">
                        <label for="username"><strong>Email</strong><span style="color: red;"> *</span></label>
                        <input pInputText type="text" formControlName="username" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.username.errors }" autocomplete="username"
                            placeholder="Enter your email" />
                        <!-- <div class="orgcode p-clickable" (click)="showOrg = true">
                            Change Organization/Email
                        </div> -->
                        <!-- <p-button class="p-text-right" label="Change Organization/Email" [link]="true" severity="info" (click)="showOrg = true"/> -->
                        <div *ngIf="submitted && f.username.errors" class="p-invalid">
                            <div *ngIf="f.username.errors.required">Email is required</div>
                        </div>
                    </div>
                    <div class="form-group p-mb-2">
                        <label for="password"><strong>Password</strong><span style="color: red;"> *</span></label>
                        <p-password formControlName="password" [feedback]="false" class="form-control"
                            [toggleMask]="true" />
                        <div *ngIf="submitted && f.password.errors" class="p-invalid">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <table style="width: 100%;">
                            <tr>
                                <!-- <td>
                                    <div class="p-field-checkbox">
                                        <p-checkbox [binary]="true" formControlName="rememberMe"></p-checkbox>
                                        <label for="rememberMe">Remember Me</label>
                                    </div>
                                </td> -->
                                <td style="text-align: right;">
                                    <div class="p-mb-3">
                                        <a [routerLink]="['/password']">Forgot Password ?</a>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="form-group">
                        <p-button type="submit" [disabled]="f.invalid" label="Sign In" icon="pi pi-user"
                            styleClass="w-10rem mx-auto" severity="info" [rounded]="true"></p-button>
                    </div>
                    <div class="form-group p-text-center p-mt-3">
                        <p-button class="p-text-right" label="Change Organization/Email" [link]="true"
                            icon="pi pi-arrow-left" [rounded]="true" severity="info" (click)="backToOrgAuth()" />
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>
<ng-container *ngIf="isShowSpinner">
    <div class="loader">
        <div class="splash-screen">
            <div class="splash-loader">
                <div class="splash-cube1"></div>
                <div class="splash-cube2"></div>
                <div class="splash-cube4"></div>
                <div class="splash-cube3"></div>
            </div>
        </div>
    </div>
</ng-container>

<div class="login-body" *ngIf="showOrg">
    <div class="login-panel p-fluid">
        <div class="p-grid">
            <div class="p-col-12 logo-container">
                <img [src]="assestBaseUrl + 'layout/images/lionO360_logo1.png'" alt="logo-dark" />
                <h1>Login</h1>
                <hr>
            </div>

            <div class="p-col-12">
                <form [formGroup]="initialLoginSetup">
                    <div class="form-group p-mb-1">
                        <label for="orgId"><strong>Organization ID</strong><span style="color: red;"> *</span></label>
                        <input id="orgId" type="text" pInputText formControlName="organizationCode" maxlength="7"
                            placeholder="Enter Organization Code" />
                    </div>
                    <div class="form-group p-mb-1">
                        <label for="email"><strong>Email</strong> <span style="color: red;"> *</span></label>
                        <input id="email" pInputText type="text" formControlName="emailId" class="form-control"
                            autocomplete="username" placeholder="Enter your email" />
                            <div class="p-invalid" [style]="{'margin-top': '-0.9rem'}">
                                <small *ngIf="initialLoginSetup.get('emailId')?.hasError('required')">
                                    Email is required
                                </small>
                                <small *ngIf="initialLoginSetup.get('emailId')?.hasError('email')">
                                    Please enter a valid email address
                                </small>
                            </div>

                    </div>
                    <div class="form-group p-d-flex p-jc-between p-ai-center"
                        [style]="{'margin-top': '1rem', 'margin-bottom': '2rem'}">
                        <div class="p-d-flex p-ai-center">
                            <p-checkbox [binary]="true" formControlName="rememberMe"></p-checkbox>
                            <label for="rememberMe" class="p-ml-2">Remember Me</label>
                        </div>

                        <div>
                            <a [routerLink]="['/forgot-organization-id']">Forgot Organization ID ?</a>
                        </div>
                    </div>
                    <div class="form-group">
                        <p-button type="submit" [disabled]="initialLoginSetup.invalid" label="Next" severity="info"
                            styleClass="w-10rem mx-auto" icon="pi pi-arrow-right" iconPos="right" [rounded]="true"
                            (click)="onInitialLoginSetupSubmit()" />
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<p-toast [baseZIndex]="999999"></p-toast>
<p-confirmDialog key="confirm-session-clear" [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
<app-authentication-setup *ngIf="authenticationSetup" [authenticationSetup]="authenticationSetup"
    [authenticationData]="authenticationData" (onSubmitAuthenPage)="onSubmitAuthenPage($event)"
    (authenSetupBackClicked)="onAuthenticationSetupBackClicked()" (onReSetupAuthen)="onReSetupAuthen($event)"
    [loginFormData]="loginFormData"> </app-authentication-setup>
